<template>
    <div>
        <template v-if="!content"></template>
        <template v-else-if="num=='3'">
            <div v-if="content.length < width/14*num">{{content}}</div>
            <el-popover v-else trigger="hover" placement="top" width="500">
                <div>{{content}}</div>
                <div slot="reference" class="overflow-3" style="height: 67px;" >
                    {{content}}
                </div>
            </el-popover>
        </template>
        <template v-else-if="num=='2'">
            <div v-if="content.length < width/14*num">{{content}}</div>
            <el-popover v-else trigger="hover" placement="top" width="500">
                <div>{{content}}</div>
                <div slot="reference" class="overflow-2" style="height: 47px;" >
                    {{content}}
                </div>
            </el-popover>
        </template>
        <template v-else-if="num=='1'">
            <div v-if="content.length < width/14*num">{{content}}</div>
            <el-popover v-else trigger="hover" placement="top" width="400">
                <div>{{content}}</div>
                <div slot="reference" class="overflow-1" style="height: 24px;" >
                    {{content}}
                </div>
            </el-popover>
        </template>
    </div>
</template>

<script>
    
// num表示显示几行
// width表示列表中该列文字的行宽
//默认一个字符的宽度是大约14，共显示大约width/14*num个字
    export default {
        props:{
            content:{type: String,default: ''},
            num:{type: Number, required: false, default: 2},
            width:{type: Number, required: false, default: 200}
        },
        components: {
           
        },
        data() {
            return {
            }
        },
        created() {

        },
        methods: {
           
        },
        mounted() {
           
        },

        computed: {
            
        },
    }

</script>

<style scoped lang="scss">
.overflow-1{
    display: -webkit-box !important;
    overflow:hidden;
    text-overflow:ellipsis;
    word-break:break-all;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:1;   /*(数字1表示隐藏两行)*/
}
</style>



// WEBPACK FOOTER //
// TableContentOverflow.vue?e6275336